import { useQuery, useMutation } from "@tanstack/react-query";
import clientPortalAxiosInstance from "../../common/utilities/axios/clientPortalAxiosInstance";
import sleep from "sleep-promise";

export const useGetAdminMessagesListQuery = () => {
  return useQuery({
    queryKey: ["getAdminMessagesListQuery"],
    queryFn: () => {
      // sleep(2000);
      return clientPortalAxiosInstance
        .get(`/User-Profile/client/adminMessage`)
        .then((res) => res.data);
    },
  });
};

// api for create admin msg
export const useCreateAdminMessageMutation = () => {
  return useMutation({
    mutationFn: ({ body }) => {
      return clientPortalAxiosInstance.post(
        `/User-Profile/client/createAdminMessage`,
        body
      );
    },
  });
};

// api for delete admin msg
export const useDeleteAdminMessageByIdMutation = () => {
  return useMutation({
    mutationFn: ({ Id }) => {
      return clientPortalAxiosInstance.delete(
        `/User-Profile/client/deleteAdminMessage/${Id}`
      );
    },
  });
};

// api for update admin msg by msg id
export const useUpdateAdminMessageByIdMutation = () => {
  return useMutation({
    mutationFn: ({ body, Id }) => {
      return clientPortalAxiosInstance.put(
        `/User-Profile/client/updateAdminMessage/${Id}`,
        body
      );
    },
  });
};

// api for getting admin msg by id
export const useGetAdminMessageByIdQuery = ({ Id }) => {
  return useQuery({
    queryKey: ["getAdminMessageById", `${Id}`],
    queryFn: () => {
      // sleep(2000);
      return clientPortalAxiosInstance
        .get(`/User-Profile/client/adminMessage/${Id}`)
        .then((res) => {
          return res.data;
        });
    },
    // The query will not execute until the Id exists
    enabled: !!Id,
  });
};
